// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  display: flex;
  min-height: 100vh;
  flex-direction: row;
}

.image-container {
  flex: 2 1;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/revicon-1dadd.appspot.com/o/1-web%2F0010%20Vizuali%20web%2F4-kongres-nexus-1920x1080.jpg?alt=media&token=423fd8d0-09bb-459b-a73c-78c396b77bfb");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.form-container {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f4f4;
  padding: 40px;
}

.login-card {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
}

.login-card h2 {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.8rem;
}

.login-card label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.login-card input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

.login-card button {
  width: 100%;
  padding: 1rem;
  background-color: #bf2121;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
}

.login-card p {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
}
.questionnaire-card {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 900px;
}

.question-block {
  margin-bottom: 2rem;
}

.question-text {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.question-divider {
  margin-top: 1.5rem;
  border: none;
  border-top: 1px dashed #ccc;
}

.submit-container {
  text-align: center;
  margin-top: 2rem;
}

.submit-container button {
  padding: 0.75rem 1.5rem;
  background-color: #0066cc;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}

.profile-card {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 1000px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.section {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 1.5rem;
  color: #2b6cb0;
  margin-bottom: 1rem;
}

input[type="text"], input[type="number"], input[type="email"], input[type="date"] {
  width: 100%;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .page-container {
    flex-direction: column;
    min-height: 100vh;
  }

  .image-container {
    display: none;
  }

  .form-container {
    flex: none;
    width: 100%;
    height: 100vh;
    padding: 20px;
  }

  .login-card {
    max-width: 100%;
    box-shadow: none;
    border-radius: 0;
    padding: 2rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kNAAkN;EAClN,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":[".page-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: row;\n}\n\n.image-container {\n  flex: 2;\n  background-image: url(\"https://firebasestorage.googleapis.com/v0/b/revicon-1dadd.appspot.com/o/1-web%2F0010%20Vizuali%20web%2F4-kongres-nexus-1920x1080.jpg?alt=media&token=423fd8d0-09bb-459b-a73c-78c396b77bfb\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.form-container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f4f4f4;\n  padding: 40px;\n}\n\n.login-card {\n  background: white;\n  padding: 3rem;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-card h2 {\n  margin-bottom: 2rem;\n  text-align: center;\n  font-size: 1.8rem;\n}\n\n.login-card label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n}\n\n.login-card input {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1.5rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n}\n\n.login-card button {\n  width: 100%;\n  padding: 1rem;\n  background-color: #bf2121;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.login-card p {\n  margin-top: 1.5rem;\n  text-align: center;\n  font-size: 0.9rem;\n}\n.questionnaire-card {\n  background: white;\n  padding: 3rem;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 900px;\n}\n\n.question-block {\n  margin-bottom: 2rem;\n}\n\n.question-text {\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.question-divider {\n  margin-top: 1.5rem;\n  border: none;\n  border-top: 1px dashed #ccc;\n}\n\n.submit-container {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.submit-container button {\n  padding: 0.75rem 1.5rem;\n  background-color: #0066cc;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.profile-card {\n  background: white;\n  padding: 3rem;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 1000px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.section {\n  margin-bottom: 2rem;\n}\n\n.section-title {\n  font-size: 1.5rem;\n  color: #2b6cb0;\n  margin-bottom: 1rem;\n}\n\ninput[type=\"text\"], input[type=\"number\"], input[type=\"email\"], input[type=\"date\"] {\n  width: 100%;\n  padding: 0.75rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .page-container {\n    flex-direction: column;\n    min-height: 100vh;\n  }\n\n  .image-container {\n    display: none;\n  }\n\n  .form-container {\n    flex: none;\n    width: 100%;\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .login-card {\n    max-width: 100%;\n    box-shadow: none;\n    border-radius: 0;\n    padding: 2rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
